import {ChangeDetectorRef, Component, HostBinding, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {OverlayContainer} from '@angular/cdk/overlay';
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {CookieService} from 'ngx-cookie-service';
import {MediaMatcher} from "@angular/cdk/layout";
import config from '../../frontend_config.json';

import {LanguageService} from './language/language.service';

@Component({
  selector   : 'app-root',
  templateUrl: './app.component.html',
  styleUrls  : ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = config['application_1_name'];
  config = config;
  currentYear: number = new Date().getFullYear();
  showCookieBanner = false;
  showCookieManageButton = false;

  mobileQuery: MediaQueryList;
  @HostBinding('class') className = '';

  toggleControl = new FormControl(false);
  private _mobileQueryListener: () => void;

  constructor(public languageService: LanguageService,
              private route: ActivatedRoute,
              public router: Router,
              private cookieService: CookieService,
              private overlay: OverlayContainer,
              changeDetectorRef: ChangeDetectorRef, media: MediaMatcher) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  changeLang(lang: string): void {
    this.languageService.changeLanguage(lang);
    window.location.reload();
  }

  cookie_info() {
    if (this.readCookieConsent() !== 'accepted') {
      this.showCookieBanner = true;
      this.showCookieManageButton = false;
    }
  }

  ngOnInit(): void {
    this.initializeCookieConsent();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const scrollableContent = document.querySelector('mat-sidenav-content');
        if (scrollableContent) {
          scrollableContent.scrollTop = 0;
        }
        window.scrollTo(0, 0);
      }
    });

    const darkClassName = 'darkMode';

    if (!this.cookieService.check('mode')) {
      this.className = '';
      this.cookieService.set('mode', 'light', {path: ''});
    }
    if (this.cookieService.get('mode') === 'dark') {
      this.className = darkClassName
      document.body.classList.add(darkClassName)
      this.overlay.getContainerElement().classList.add(darkClassName);
      this.toggleControl.setValue(true)
    }

    this.toggleControl.valueChanges.subscribe((darkMode) => {
      this.className = darkMode ? darkClassName : '';
      if (darkMode) {
        this.cookieService.set('mode', 'dark', {path: ''});
        document.body.classList.add(darkClassName)
        this.overlay.getContainerElement().classList.add(darkClassName);
      } else {
        this.cookieService.set('mode', 'light', {path: ''});
        document.body.classList.remove(darkClassName)
        this.overlay.getContainerElement().classList.remove(darkClassName);
      }
    });
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  acceptCookies(): void {
    const previousConsent = this.readCookieConsent();
    this.cookieService.set('cookies_consent', 'accepted', 365, '/');
    if (previousConsent === 'rejected') {
      window.location.reload();
      return;
    }

    this.showCookieBanner = false;
    this.showCookieManageButton = true;
  }

  rejectCookies(): void {
    const previousConsent = this.readCookieConsent();
    this.cookieService.set('cookies_consent', 'rejected', 30, '/');
    if (previousConsent === 'accepted') {
      window.location.reload();
      return;
    }

    this.showCookieBanner = false;
    this.showCookieManageButton = true;
  }

  openCookieSettings(): void {
    this.showCookieBanner = true;
    this.showCookieManageButton = false;
  }

  private initializeCookieConsent(): void {
    const consent = this.readCookieConsent();
    if (consent === 'accepted') {
      this.showCookieBanner = false;
      this.showCookieManageButton = true;
      return;
    }

    this.showCookieBanner = true;
    this.showCookieManageButton = false;
  }

  private readCookieConsent(): string {
    if (!this.cookieService.check('cookies_consent')) {
      return '';
    }

    return this.cookieService.get('cookies_consent');
  }
}

